import { Helmet } from "react-helmet";
import SolutionsNtunaCTAWorld from "../components/solutions/SolutionsNtunaCTAWorld";
import HowWeWork from "../components/solutions/HowWeWork";
import ClientsBody from "../components/clients/ClientsBody";

export default function Clients() {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://www.ntuna.com/solutions/clients" />
        <meta
          name="description"
          content="Discover businesses and organizations that have trusted NTUNA.COM for their Website, systems and app development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        
        <meta
          property="og:description"
          content="Discover businesses and organizations that have trusted NTUNA.COM for their Website, systems and app development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta
          property="og:title"
          content="Our Clients | Businesses & Organizations That Trust NTUNA.COM"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta
          name="twitter:title"
          content="Our Clients | Businesses & Organizations That Trust NTUNA.COM"
        />
        <meta
          name="twitter:text:title"
          content="Our Clients | Businesses & Organizations That Trust NTUNA.COM"
        />
        <meta
          name="twitter:description"
          content="Discover businesses and organizations that have trusted NTUNA.COM for their Website, systems and app development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>
          Our Clients | Businesses & Organizations That Trust NTUNA.COM
        </title>
      </Helmet>
      <ClientsBody />
      <HowWeWork />
      <SolutionsNtunaCTAWorld />
    </>
  );
}
